import { useParams } from 'react-router-dom';
import { Box, Paper } from '@mui/material';
import { OrderForm } from '../components/OrderForm/OrderForm';


export default function OrderFormPage() {
  const { id } = useParams();

  return (
    <Box sx={{ p: { xs: 1, md: 3 }, maxWidth: 900, margin: '0 auto' }}>
      <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 4, boxShadow: '0 2px 12px 0 rgba(16,30,54,0.06)' }}>
        <OrderForm orderId={id} />
      </Paper>
    </Box>
  );
}